const Form004TC = {
    stepName: {
        statement: "陳述",
        basicInformation: "計劃基本資料",
        activitiesHeldWithSchool: "與學校協作的活動",
        activitiesOpenToCommunity: "服務整個地區的活動",
        total: "合計",
        confirmation: "確認",
    },
    statement: {
        tips1: "1. 電子表格所載的資料均以教育局網頁上之表格為準",
        tipsUrl:
            "https://www.edb.gov.hk/tc/student-parents/support-subsidies/after-sch-learning-support-program/community-based-projects/index.html",
        tips2: "2. 校本課後學習及支援計劃區本計劃運作實況簡報（截至該學年的10月15日為止）（本表經填妥及簽署後須於該學年的10月31日或以前提交教育局學生特別支援組）",
    },
    button: {
        addActivity: "新增活動",
        removeActivity: "移除活動",
        addSchool: "新增協作學校",
        removeSchool: "移除協作學校",
    },
    label: {
        statement: "聲明",
        statementCheck: "本人已閱讀、明白及同意上述條款及細則",
        basicInformation: "基本資料",
        organisationName: "機構名稱",
        projectTitle: "計劃名稱",
        applicationRefNO: "計劃編號",
        projectCoordinator: "計劃統籌員姓名",
        contactPerson: "聯絡人姓名",
        contactTelNo: "聯絡電話",
        tips: "請填寫所有核准活動的資料",
        activitiesSchool: "(I) 與學校協作的活動（列明所有獲批活動）",
        ngoChopFile: "非政府機構／非政府機構的部門／非政府機構的附屬機構印鑑",
        approvedProject: "核准計劃資料：",
        activityName: "活動名稱",
        schoolName: "協作學校名稱",
        actualSituation: "實際情況：",
        other: "其他",
        stepOption: {
            ActivitiesHeldWithSchool: "與學校協作的活動",
            ActivitiesOpenToCommunity: "服務整個地區的活動",
        },
        selectContent: "請填寫所有核准活動的資料：",
        actualSituationOption: {
            completed: "已完成",
            inProgress: "正在進行",
            notCommenced: "未開展",
            cancelled: "擬取消",
            adjustment: "需修訂",
        },
        remark: "備註",
        remarkEg: "如註明活動日期，例：逢星期一、三、五下午4:00-5:30",
        activitiesTotal1: "活動項目總數（a1）",
        activitiesTotal2: "活動項目總數（a2）",
        schoolsTotal: "學校總數",
        completedTotal: "已完成活動總數",
        inProgressTotal: "正在進行活動總數",
        notCommencedTotal: "未開展活動總數",
        cancelledTotal: "擬取消活動總數",
        adjustmentTotal: "需修訂活動總數",
        activitiesCommunity: "(II) 服務整個地區的活動（列明所有獲批活動）",
        a1a2Total: "合計：（I）+（II）的核准活動項目總數＝（a1）+（a2）",
        ngoType: "非政府機構／非政府機構的部門／非政府機構的附屬機構名稱",
        ngoName: "{{ngoType}}名稱",
        ngoHeadType:
            "非政府機構／非政府機構的部門／非政府機構的附屬機構負責人／計劃統籌員",
        ngoHeadTypeName: "{{ngoType}}負責人／計劃統籌員",
        ngoHeadName: "姓名",
        ngoHeadPost: "職位",
        ngoHead: "{{ngoType}}負責人",
    },
    select: {
        ngoOption: {
            ngo: "非政府機構",
            department: "非政府機構的部門",
            subsidiaryOrganisation: "非政府機構的附屬機構",
        },
        ngoHeadOption: {
            ngoHead: "非政府機構／非政府機構的部門／非政府機構的附屬機構負責人",
            projectCoordinator: "計劃統籌員",
        },
    },
    errorMsg: {
        "E-0000": "Nominee Title is required [E-0000]",
        "E-0001": "Nominee Name is required [E-0001]",
        "E-0100": "Reward Nomination is required [E-0100]",
        "E-0101":
            "包含英文字符、空格、點、逗號、連字符和單引號。數字是不允許的。",
        "E-0102": "僅限中文",
        "E-0103": "如果中文商業代碼中的中文名稱不為空，則不得為空。",
        "E-0104": "僅字母表",
        "E-0105": "僅字母數字",
        "E-0106":
            "包含數字字符和特殊字符，特殊字符只包含空格（）、加號（+）、井號（#）、括號（ () ）和連字符（-）",
        "E-0107": "僅數字",
        "E-0108":
            "允許小數點後一位。包含數字字符和特殊字符，特殊字符只包含空格（）、加號（+）、井號（#）、括號（ () ）、連字符（-）和斜杠（/）。",
        "E-0109": " 與20XX\\XX格式不匹配",
        "E-0110": "該值在出生日期之後.",
        "E-0111": "必須至少有一個文件",
        "E-0112": "不能超過2個文件",
        "E-0113": "不符合香港身份證規則",
        "E-0114": "最小長度8",
        "E-0115": "最大長度為20",
        "E-0116":
            "特殊字符只包含空格（）、加號（+）、井號（#）、括號（ () ）和連字符（-）",
        "E-0117":
            "最大長度（默認值100）、字符類型（僅字母／字母數字／僅中文）、模式",
        "E-0118": "請選擇最少1項",
        "E-0119": "此項最多只能包含{{number}}個字符",
        "E-0120": "此項必須至少包含{{number}}個字符",
    },
};
export default Form004TC;
